import { MoreButton } from '#components/base/MoreButton/MoreButton';
import { TrackEventDataType } from '#types/tracking';

import { ArticleItemResultsItem } from '../ArticleItemResultsItem';

import { SearchNoResults } from './SearchNoResult';
import styles from './SearchResults.module.scss';
import type { SearchResultsFragment } from './__generated__/SearchResults.generated';

type Props = {
	hasNextPage: boolean;
	isLoading: boolean;
	onLoadMore?: () => void;
	searchResultArticles: NonNullable<NonNullable<SearchResultsFragment['edges']>[number]['node']>[];
	totalCount: number | null;
};

function getCount(totalCount: number | null, shownResultsCount: number) {
	if (totalCount === null) {
		return undefined;
	}

	return totalCount - shownResultsCount;
}

export function SearchResults({ hasNextPage, onLoadMore, searchResultArticles, isLoading, totalCount }: Props) {
	if (searchResultArticles.length === 0) {
		return (
			<section className={styles.wrapper}>
				<SearchNoResults className={styles.noResults} />
			</section>
		);
	}

	const count = getCount(totalCount, searchResultArticles.length);
	const ariaLabel = `Mehr anzeigen (${count} weitere Artikel)`;

	return (
		<section className={styles.wrapper}>
			<h2 className={`${styles.title} heading3`}>Neuste Artikel</h2>
			{searchResultArticles.map((article) => {
				return (
					<ArticleItemResultsItem
						article={article}
						key={article.rowId}
						trackEventDataType={TrackEventDataType.SearchArticleClick}
						className={styles.result}
					/>
				);
			})}

			{hasNextPage && (
				<MoreButton className={styles.moreButton} onClick={onLoadMore} disabled={isLoading} count={count} aria-label={ariaLabel}>
					Mehr laden
				</MoreButton>
			)}
		</section>
	);
}
